import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_68rnwdnrcq: FaireBrandEntity = {
  token: "b_68rnwdnrcq",
  type: "brand",
  name: "Salt & Sage Apothecary",
  avatarUrl:
    "https://cdn.faire.com/fastly/b29b2065ea4fee7899ea1eda9208933e1ff07e9c598ac5f4587236e8c455d59c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/35b6ed5dce7316cd061b786d52c30783c7cff0fd49fcc8cf23378b8a90adeff8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b29b2065ea4fee7899ea1eda9208933e1ff07e9c598ac5f4587236e8c455d59c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/35b6ed5dce7316cd061b786d52c30783c7cff0fd49fcc8cf23378b8a90adeff8.jpeg",
  location: "Fayetteville, NC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    " Hey there! My name is Nicole and I am the face behind Salt & Sage Apothecary, a female and service disabled veteran owned and operated business. I embarked on this journey in 2020, during the pandemic, when I found myself facing a new challenge when my brick and mortar wellness center was forced to close. I took the closure as an opportunity to expand our offerings beyond the physical center, venturing into online sales and gradually creating our own line of natural, eco-friendly products. \n\nFrom salt soaks to body butters, shower steamers to soaps, I am passionate about curating skincare items that are free from harsh chemicals, synthetic fragrances, and dyes. Sustainability is at the core of our values, as I meticulously select ethically sourced, organic ingredients and employ sustainable packaging practices. Each item in our expanding range is carefully crafted with love and expertise.\n\n At Salt & Sage Apothecary, we prioritize women's rights and strive to create a more level playing field for women. Through our business, we seek to empower and inspire, championing the strength and resilience of women everywhere. As a female-owned and operated business, I believe in the limitless potential of women entrepreneurs and aim to pave the way for others to follow their dreams. \n\nJoin me on this wellness adventure, where Salt & Sage Apothecary celebrates the power of self-care, embracing the beauty of nature one product at a time.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:57.584Z",
    importedBy: "entity-db-cli",
  },
};
